/**
 * Types for the B2B portal (login + my account)
 * Maps to C# view models in Tracker.Application (v2 b2bauth endpoints).
 */

/** Member content-type alias the layout API reports for B2B customers. */
export const B2B_USER_TYPE = "b2bCustomer";

/** Maps to C# B2bSignInViewModel (POST /api/v2/b2bauth/signin). */
export interface B2bSignInViewModel {
  redirectUrl: string | null;
  userEmail: string | null;
  userType: string | null;
}

/**
 * Editor-controlled texts on the B2bLoginPage content node
 * (maps to C# B2bLoginPageFullViewModel). All optional — the login page
 * falls back to dictionary texts when the content fetch fails.
 */
export interface B2bLoginPageContent {
  heading?: string | null;
  username?: string | null;
  password?: string | null;
  loginFailed?: string | null;
}
